import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden" data-id="element-53">
      {/* Background Image */}
      <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=2000&q=80" alt="Pes na sprehodu na povodcu" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-54" />

      {/* Tinted Overlay */}
      <div className="absolute inset-0 bg-brand-text/40" data-id="element-55"></div>

      {/* Floating Paw Badges */}
      <motion.div animate={{
      y: [0, -15, 0],
      rotate: [10, -5, 10]
    }} transition={{
      repeat: Infinity,
      duration: 6,
      ease: 'easeInOut'
    }} className="absolute top-16 right-10 md:right-20 bg-white/20 backdrop-blur-md p-3 rounded-full shadow-lg border border-white/30 z-10" data-id="element-56">
        <PawPrint className="w-8 h-8 text-white" data-id="element-57" />
      </motion.div>

      <motion.div animate={{
      y: [0, 15, 0],
      rotate: [-10, 5, -10]
    }} transition={{
      repeat: Infinity,
      duration: 5,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-20 right-1/4 bg-white/20 backdrop-blur-md p-4 rounded-full shadow-lg border border-white/30 z-10 hidden md:block" data-id="element-58">
        <PawPrint className="w-10 h-10 text-brand-pink-light" data-id="element-59" />
      </motion.div>

      <motion.div animate={{
      y: [0, -10, 0],
      rotate: [0, 15, 0]
    }} transition={{
      repeat: Infinity,
      duration: 7,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute top-32 left-8 md:left-16 bg-white/20 backdrop-blur-md p-2 rounded-full shadow-lg border border-white/30 z-10" data-id="element-60">
        <PawPrint className="w-6 h-6 text-brand-green-light" data-id="element-61" />
      </motion.div>

      {/* Content Container */}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 md:px-6 py-12 flex justify-center md:justify-start" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-brand-cream/95 backdrop-blur-sm rounded-[2.5rem] p-8 md:p-10 shadow-2xl max-w-2xl border border-white/50" data-id="element-63">
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-brand-text mb-6 leading-tight" data-id="element-64">
            Sestri za <span className="text-brand-brown" data-id="element-65">tačke</span>
          </h1>
          <p className="text-xl md:text-2xl font-medium text-brand-text/80 mb-6" data-id="element-66">
            Sprehajanje psov z veliko energije, igre in ljubezni.
          </p>
          <p className="text-lg text-brand-text/70 mb-8 leading-relaxed" data-id="element-67">
            Sva Eli in Ema, sestri, ki imava radi živali in z veseljem poskrbiva
            za sprehod, igro in osnovno skrb za vašega kužka.
          </p>
          <a href="#kontakt" className="inline-flex items-center justify-center px-8 py-4 bg-brand-pink hover:bg-brand-pink-light text-brand-text font-bold rounded-full transition-all duration-300 shadow-soft hover:shadow-lg hover:-translate-y-1 text-lg" data-id="element-68">
            Kontaktiraj naju
            <PawPrint className="ml-2 w-5 h-5" data-id="element-69" />
          </a>
        </motion.div>
      </div>
    </section>;
}